import React, { memo } from 'react';
import {    getRessouresUrl, 
            ellipsify, 
            cleanDisplayFilename,
            prettyPrintDate } from './../../utils/config';
import PdfViewerModal from './../../components/pdf-viewer/PdfViewerModal';
import ImageGallery from 'react-image-gallery';

import '@react-pdf-viewer/core/lib/styles/index.css';
import './../../assets/css/image-gallery.scss';
import './../../assets/css/style.css';

const NewsCard = (props) => {
    const news = props.data;
    const pubDate = prettyPrintDate(news.publicationDate);
    
    return (
        <div className="custom-card viewer card-shadow">
            <div className="text-container">
                {/* Title */}
                <h3>
                    { news.title }
                </h3>
                <hr />
                {/* Publication date */}
                <p className="p-tiny-text">
                    Published on {pubDate}
                </p>
                {/* Description */}
                <p className="p-reading-text pt-4">
                    { news.description }
                </p>
                {/* Uploaded documents and files */}
                {
                    news.newsDocs.length !== 0
                    ?   <div key={news._id+news.title+"docs"}>
                            <p className="p-tiny-text pt-4">
                                Documents & files
                            </p>
                            {news.newsDocs.map((doc, index) => (
                                <div key={cleanDisplayFilename(doc)+index}>
                                    <PdfViewerModal btnPrompt={cleanDisplayFilename(doc)}
                                                    modalPrompt={cleanDisplayFilename(doc)} 
                                                    ressource={getRessouresUrl()+doc}/>
                                    {index !== (news.newsDocs.length-1)
                                        ? <span><br /></span>
                                        : null
                                    }
                                </div>
                            ))}
                        </div>
                    : null
                }
                {/* Links and ressources */}
                {
                    news.links.length !== 0
                    ?   <div>
                            <p className="p-tiny-text pt-4">
                                Links and ressources
                            </p>
                            {news.links.map((data, index) => (
                                <span key={data.link+index}>
                                    <a  target="_blank" 
                                        rel="noreferrer" 
                                        draggable={false}
                                        href={data.link} >
                                            {data.display
                                                ? data.display
                                                : ellipsify(data.link)
                                            }
                                    </a>    
                                    {index !== (news.links.length-1)
                                        ? <span>, </span>
                                        : null
                                    }
                                </span>
                            ))}
                        </div>
                    : null
                }
                {/* Uploaded images */}
                {
                    news.newsImages.length !== 0
                    ? <>
                        <br />
                        <ImageGallery items={
                            news.newsImages.map(img => ({
                                original: getRessouresUrl()+img,
                                thumbnail: getRessouresUrl()+img,
                                originalHeight: 420,
                                thumbnailHeight: 30,
                            }))}
                            showNav={true}
                            showThumbnails={news.newsImages.length > 1}
                            showFullscreenButton={false}
                            showPlayButton={false}
                            autoPlay={false}
                        />
                    </>
                    : null
                }
            </div>
        </div>);

};

export default memo(NewsCard);
